import Vue from "vue";
import Vuex from "vuex";
import { rest } from "@/utilities";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: {
      subscriptions: [],
      username: null,
      intent: null,
      customer: null,
      stripePublicKey: null,
      isSubscriptionLessCustomer: false
    },
    plans: [],
    intent: null,
    pendingSubscription: null
  },
  getters: {
    user: state => state.user,
    plans: state => state.plans,
    subscriptions: state => state.user.subscriptions || [],
    authenticated: state => state.user.username !== null,
    customer: state => state.user.customer,
    stripePublicKey: state => state.user.stripePublicKey,
    pendingSubscription: state => state.pendingSubscription
  },
  mutations: {

    setUser: (state, payload) => {
      state.user = payload;
    },

    setSubscription: (state, payload) => {
      state.pendingSubscription = payload;
    },

    setPlans: (state, payload) => {
      state.plans = payload;
    },

    setIntent: (state, payload) => {
      state.intent = payload;
    }

  },
  actions: {
    
    fetchUserInfo: ({ commit }) => {
      return new Promise((resolve, reject) => {
        rest.get("SignUp/", "FetchUserInfo", "json", {})
          .done(response => {
            commit("setUser", response);
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    plans: ({ commit }) => {
      return new Promise((resolve, reject) => {
        rest.get("SignUp/", "Plans", "json", {})
          .done(response => {
            commit("setPlans", response);
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    createCustomer: () => {
      return new Promise((resolve, reject) => {
        rest.post("SignUp/", "CreateCustomer", "json", {})
          .done(response => {
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    createOrGetSubscription: ({ commit }, plan) => {
      
      return new Promise((resolve, reject) => {
        rest.post("SignUp/", "CreateOrGetSubscription?priceId=" + plan, "json")
          .done(response => {
            commit("setSubscription", response);
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    applyCoupon: ({ commit }, { subscriptionId, coupon }) => {

      return new Promise((resolve, reject) => {
        rest.post("SignUp/", `ApplyCoupon?subscriptionId=${subscriptionId}&coupon=${coupon}`, "json")
          .done(response => {
            commit("setSubscription", response);
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    createSubscription: ({ commit }, coupon) => {
      const path = coupon === null ? "CreateSubscription" : "CreateSubscription?coupon=" + coupon;
      return new Promise((resolve, reject) => {
        rest.post("SignUp/", path, "json", {})
          .done(response => {
            commit("setIntent", response);
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    verifySubscription: ({}, subscriptionId) => {
      return new Promise((resolve, reject) => {
        rest.get("SignUp/", "VerifySubscription", "json", { subscriptionId: subscriptionId })
          .done(response => {
            resolve(response);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    createVerificationCode: ({}, email) => {
      return new Promise((resolve, reject) => {
        rest.get("SignUp/", "CreateVerificationCode", "json", { email: email })
          .done(response => {
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },

    createUserAccount: ({ }, payload) => {
      return new Promise((resolve, reject) => {
        rest.post("SignUp/", "CreateUserAccount", "json", JSON.stringify(payload))
          .done(response => {
            resolve(true);
          }).fail(xhr => {
            reject(rest.parseError(xhr));
          });
      });
    },
  }
});
